<template>
  <div class="button temr">
    <van-button
      type="danger"
      class="left"
      v-if="params.isShowReturnBtn"
      @click="handlerClick"
      >返回</van-button
    >
    <van-button
      type="danger"
      :disabled="disabled"
      @click="click"
      :loading="loading"
      :loadingText="loadingText"
      >{{text}}</van-button
    >
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
  name: 'Button',
  props: ['disabled', 'loading', 'click', 'text', 'loadingText', 'params'],
  methods: {
    ...mapMutations('publicPage', ['updateState']),
    handlerClick() {
      this.updateState({
        tabActive: 1,
      });
    },
  },
};
</script>
<style scoped>
.button {
  padding-right: 15px;
  height: 68px;
  background: #fff;
  padding-left: 15px;
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 0;
  width: 100%;
  box-sizing: border-box;
  position: fixed;
}
.button >>> .van-button {
  width: 100%;
}
.button >>> .van-button__text {
  font-family: PingFangSC-Semibold;
  font-size: 18px;
  color: #FFFFFF;
  font-weight: 600;
}
.van-button--disabled {
  color: #fff;
  background-color: #7691a3 !important;
  border: 1px solid #7691a3 !important;
}
.van-button--danger {
  background: #ff6538;
  border-radius: 4px;
  font-size: 17px;
}
.van-button--normal {
  font-size: 17px;
}
.left{
  background: #F5F5F5;
  border-color: #F5F5F5;
  margin-right: 15px;
}
.left >>> .van-button__text{
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #2F3133;
  font-weight: 400;
}
.temr::after {
  position: absolute;
  right: 0;
  top: 0;
  left: 0;
  box-sizing: border-box;
  border-bottom: 1px solid #ccc;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: ' ';
  pointer-events: none;
}
</style>
